<template>
  <v-dialog
    v-model="visivel"
    persistent
    width="auto"
    height="auto"
    @click:outside="cancela">
    <v-card class="mt-3 pa-4" outlined>
      <button class="float-right" @click="cancela">
        <v-icon color="primary">close</v-icon>
      </button>

      <v-card-title
        class="flex-column justify-center primary--text font-weight-bold clear-both">
        <v-icon size="100" color="primary">{{ icon }}</v-icon>
        <p>{{ mensagem }}</p>
      </v-card-title>

      <v-card-text class="text-center">
        {{ corpoMensagem }}
      </v-card-text>
      <v-card-actions class="justify-center">
        <slot>
          <template v-if="tipo === 'confirma'">
            <v-btn class="text-capitalize" color="primary" @click="confirma"
              >Sim</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              class="text-capitalize"
              outlined
              color="primary"
              @click="cancela"
              >Não</v-btn
            >
          </template>
          <template v-else>
            <v-btn
              block
              class="text-capitalize"
              color="primary"
              @click="confirma"
              >Ok</v-btn
            >
          </template>
        </slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    tipo: {
      type: String,
    },
    mensagem: {
      type: String,
    },
    corpoMensagem: {
      type: String,
    },
    visivel: {
      type: Boolean,
    },
  },
  methods: {
    cancela() {
      this.$emit("close")
    },
    confirma() {
      this.$emit("close")
      this.$emit("confirma")
    },
  },
  computed: {
    icon() {
      switch (this.tipo) {
        case "informa":
          return "mdi-check-circle-outline"

        case "alerta":
          return "mdi-alert-circle-outline"

        case "confirma":
          return "mdi-cancel"

        default:
          return this.tipo
      }
    },
  },
}
</script>

<style>
.clear-both {
  clear: both;
}
</style>
